module.exports = __webpack_public_path__ + "./img-irene_825d4c85d55850b353e2202df55cfe45.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2017/img-irene.png
// module id = 446
// module chunks = 0